module.exports = __webpack_public_path__ + "img/spain.8418b57b.svg";